<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="ReplaceQuestionModal"
  >
    <template
      #modal-header
    >
      <h2 class="u-text-center">
        Score Breakdown
      </h2>
      <hr>
    </template>
    <template #modal-body>
      <table>
        <thead>
          <tr>
            <th style="width: 85%">
              Question
            </th>
            <th
              class="align-text-center"
              style="width: 15%;"
            >
              Score
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(breakdown, index) in scoreBreakdown"
            :key="index"
          >
            <td>{{ breakdown.label }}</td>
            <td class="align-text-center">
              {{ breakdown.score }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Close
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
  props: {
    scoreBreakdown: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="less" scoped>

</style>
